// http://momentjs.cn/docs/#/parsing/
// 文档地址

import moment from 'moment'

export default moment
